<button mat-mini-fab color="white" matTooltip="Collapse/expand menu"
        (click)="sideNavService.toggle()">
  <i class="fas fa-bars"></i>
</button>
